import Abstract from "../../abstract-view/abstract.js";

import {
  createElement
} from "../../render/render.js";

import {
  CATALOG_URL
} from "../const.js";

const createSuccessNotificationMarkup = (orderNum, orderCreatedon) => {
  return (
    `<div class="cart-heading-wrapper cart-heading-wrapper_success">
      <h1 class="heading heading_h1 heading_no-margins heading_category heading_cart">Спасибо, ваш заказ №${orderNum} от ${orderCreatedon} успешно создан</h1>
      <p class="cart-success-notification-text">Наш менеджер свяжется с вами для подтверждения заказа в ближайшее время.</p>
      <a class="button button_cart-success-notification" href="${CATALOG_URL}">Перейти в каталог</a>
    </div>`
  );
};

export default class TitleSection extends Abstract {
  constructor(element, orderNum, orderCreatedon) {
    super();

    this._element = element;
    this._orderNum = orderNum;
    this._orderCreatedon = orderCreatedon;

    this._productsWrapperElement = null;
    this._cartHeadingWrapperElement = null;
    this._successNotificationElement = null;
  }

  getProductsWrapperElement() {
    if (!this._productsWrapperElement) {
      this._productsWrapperElement = this._element.querySelector(`.cart-products-wrapper`);
    }

    return this._productsWrapperElement;
  }

  getCartHeadingWrapperElement() {
    if (!this._cartHeadingWrapperElement) {
      this._cartHeadingWrapperElement = this._element.querySelector(`.cart-heading-wrapper`);
    }

    return this._cartHeadingWrapperElement;
  }

  getSuccessNotificationElement() {
    if (!this._successNotificationElement) {
      this._successNotificationElement = createElement(this._getSuccessNotificationTemplate());
    }

    return this._successNotificationElement;
  }

  _getSuccessNotificationTemplate() {
    return createSuccessNotificationMarkup(this._orderNum, this._orderCreatedon);
  }
}
